/* 
Author:Lamiaa Moustafa
Desc: Reusable Footer component
*/
import React from "react";
import styled from "styled-components";
import Text1st2911 from "../components/text/Text1st2911";
import { Link } from "react-router-dom";
import { FooterText } from "../Styles/styledComponents/Text";

export const Footer1st2911 = () => {
  return (
    <>
      <Footer>
        <Text1st2911
          data={{
            text: "Copyright@2023 covertalert. All Rights Reserved",
            customStyle: FooterText,
          }}
        ></Text1st2911>
        <LinkDiv>
          <Link to="/contact">Contact Us |</Link>
          <Link to="/faq">FAQ |</Link>
          <Link to="/termofuse">Terms of Use</Link>
        </LinkDiv>
      </Footer>
    </>
  );
};

const Footer = styled.footer`
  width: 100vw;
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 3vh;
  background-color: var(--white);
  position: absolute;
  bottom: 0;
  z-index: 100;
  border-top: 1px solid var(--orange);
  @media (max-width: 768px) {
     position: fixed;
    height: 5vh;
    left:0;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  p {
    font-size: 14px;
  }
`;

const LinkDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;

  a {
    margin: 0 5px;
    font-family: var(--fontFamily);
    color: var(--black);
    &:hover {
      color: var(--orange);
      text-decoration: underline;
    }
  }
`;
